import { AreaUrl } from '../details-overlay.constants';
import { DetailsOverlayData } from '../details-overlay.model';
import { UnaccountedSpaceClass } from '../../../../../../models/space/unaccounted-space.class';

export const UNACCOUNTED_CONFIG: DetailsOverlayData<UnaccountedSpaceClass> = {
  title: space => space.getTitle(),
  subsets: [
    {
      label: 'commonLabels.spaceSize',
      dataField: 'spaceSize',
      unit: {
        lookupCategory: AreaUrl,
        displayFn: space => space.getAreaSpaceUOM(),
      },
      displayFn: space => space.getAreaSpace(),
      isAreaField: true,
    },
  ],
  removeIdInTitle: true,
  notesUpdate: [],
};
